export default __webpack_public_path__ + "static/media/cif-ga.95cab496.svg";